<template>
  <el-dialog
    title="附件挂载"
    :visible="visible"
    :modal="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    width="100%"
    top="0"
    class="linkfile-dialog"
    @open="handleOpen"
    @close="$emit('update:visible', false)"
    @closed="$emit('closed')"
  >
    <div>
      <div>文件分类说明:</div>
      <div class="linkfile-tip-content">
        【人选】： 简历、推荐报告、会面记录、人选薪酬、测评等。<br />
        【公司】： 公司/部门mapping、合同、公司模版、公司信息、简介等。<br />
        【项目】： 项目mapping报告、岗位搜寻报告、与项目相关的薪酬报告等。<br />
        【知识库】： 行业知识、行业薪酬报告、行业趋势、职能模块认知学习等。
      </div>
    </div>
    <div v-if="showTip">
      <div>系统建议:</div>
      <div class="linkfile-tip-content">系统建议该附件是下列人选附件的{{ result.姓名 }}，如果不是请自行更改</div>
    </div>
    <div>
      <div class="linkfile-label"><span class="text-red">*</span> <span>请选择这份附件的归属类型（单选）</span></div>
      <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="人选附件" name="人选附件">
            <div v-if="activeName == '人选附件'">
              <div class="linkfile-label">
                <span class="text-red">*</span> <span>搜索需要绑定的人选，点击选择（单选）</span>
                <span class="text-yellow">（同一附件不支持挂载多人）</span>
              </div>
              <div>
                <div class="linkfile-search">
                  <el-input
                    v-model="keywords"
                    class="mb10"
                    placeholder="输入姓名、公司搜索人选，空格区分，按回车搜索"
                    size="mini"
                    clearable
                    @keypress.enter.native="searchRadish"
                  >
                    <el-button
                      slot="append"
                      type="primary"
                      size="mini"
                      style="color: #FFF;background-color: #409EFF;"
                      @click="searchRadish"
                    >
                      搜索
                    </el-button>
                  </el-input>
                </div>
                <div>
                  <div>您要找的是：</div>
                  <table v-if="radishes.length > 0" class="simple-table" cellspacing="0" style="width:100%">
                    <tr>
                      <th>操作</th>
                      <th>姓名</th>
                      <th>公司</th>
                      <th>部门</th>
                      <th>目前职位</th>
                      <th>职能模块</th>
                    </tr>
                    <tr v-for="(radish, k) in radishes" :key="k">
                      <td><el-button type="primary" size="mini" @click="chooseRadish(radish._id)">选择</el-button></td>
                      <td>
                        <a :href="`#/radish-detail-blank/${radish._id}`" target="_blank">{{ radish.姓名 }}</a> <br />
                        <span>{{ radish.手机 }}</span>
                      </td>
                      <td>{{ radish.公司 }}</td>
                      <td>{{ radish.部门 }}</td>
                      <td>{{ radish.目前职位 }}</td>
                      <td>{{ radish.职能模块 }}</td>
                    </tr>
                  </table>

                  <div style="padding: 5px 10px;">
                    <el-button type="text" @click="showAddRadish">没有该人选，新建</el-button>
                  </div>
                </div>
                <div v-if="result._id">
                  <div>已选择人选:</div>
                  <div class="linkfile-result">
                    <span>
                      <a :href="`#/radish-detail-blank/${result._id}`" target="_blank">{{ result.姓名 }}</a>
                    </span>
                    &nbsp; <span>{{ result.公司 }}</span
                    >&nbsp;<span>{{ result.部门 }}</span
                    >&nbsp;<span>{{ result.目前职位 }}</span> &nbsp; <span>{{ result.职能模块 }}</span>
                  </div>
                </div>
              </div>
              <div class="linkfile-type">
                <div class="linkfile-label">
                  <span class="text-red">*</span> <span>请确认该附件具体类型（单选）</span
                  ><span class="text-yellow"> （人选附件类型如下，点击选择） </span>
                </div>
                <div class="linkfile-tags">
                  <el-radio
                    v-for="(type, k) in radishFileTypes"
                    :key="k"
                    v-model="formData.type"
                    size="small"
                    border
                    :label="type"
                    >{{ type }}
                  </el-radio>
                </div>
                <div class="linkfile-label">该附件是否需要特殊标签，请勾选</div>
                <div class="linkfile-tags">
                  <el-checkbox-group v-model="teshuTag">
                    <el-checkbox v-for="(type, k) in tagTypes" :key="k" :label="type">{{ type }} </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="linkfile-label">该附件是否同步到薪酬库，请勾选</div>
                <div class="linkfile-tags">
                  <el-radio v-model="isTongbu" size="small" :label="true">请同步 </el-radio>
                  <el-radio v-model="isTongbu" size="small" :label="false">暂不同步 </el-radio>
                </div>
                <div class="linkfile-text-center">
                  <el-button size="mini" type="primary" @click="bindRadish">确认绑定</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="公司附件" name="公司附件">
            <div v-if="activeName == '公司附件'">
              <div class="linkfile-label">
                <span class="text-red">*</span><span>搜索需要绑定的公司，点击选择（单选）</span
                ><span class="text-yellow">（同一附件不支持挂载多家公司）</span>
              </div>
              <div>
                <div class="linkfile-search">
                  <el-select
                    v-model="keywords"
                    size="mini"
                    placeholder="输入公司的全称或简称"
                    filterable
                    remote
                    :remote-method="searchCompany"
                    :loading="loading"
                    style="width:100%"
                    @change="chooseCompany"
                  >
                    <el-option v-for="item in companies" :key="item._id" :value="item._id" class="linkfile-search-item">
                      <el-button type="primary" size="mini">选择</el-button>
                      <span>{{ item.公司名称 }}</span> <span>（简称:{{ item.简称 }}）</span>
                    </el-option>
                  </el-select>
                </div>
                <div v-if="result._id">
                  <div>已选择公司:</div>
                  <div class="linkfile-result">
                    <span>{{ result.公司名称 }}</span> <span>（简称:{{ result.简称 }}）</span>
                  </div>
                </div>
              </div>
              <div class="linkfile-type">
                <div class="linkfile-label">
                  <span class="text-red">*</span><span>请确认该附件具体类型（单选）</span
                  ><span class="text-yellow"> （公司附件类型如下，点击选择） </span>
                </div>
                <div class="linkfile-tags">
                  <el-radio
                    v-for="(type, k) in companyFileTypes"
                    :key="k"
                    v-model="formData.type"
                    size="small"
                    border
                    :label="type"
                    >{{ type }}
                  </el-radio>
                </div>
                <div class="linkfile-label">该附件是否需要特殊标签，请勾选</div>
                <div class="linkfile-tags">
                  <el-checkbox-group v-model="teshuTag">
                    <el-checkbox v-for="(type, k) in tagTypes" :key="k" :label="type">{{ type }} </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="linkfile-label">该附件是否同步到薪酬库，请勾选</div>
                <div class="linkfile-tags">
                  <el-radio v-model="isTongbu" size="small" :label="true">请同步 </el-radio>
                  <el-radio v-model="isTongbu" size="small" :label="false">暂不同步 </el-radio>
                </div>
                <div class="linkfile-text-center">
                  <el-button size="mini" type="primary" @click="bindCompany">确认绑定</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="项目附件" name="项目附件">
            <div v-if="activeName == '项目附件'">
              <div class="linkfile-label">
                <span class="text-red">*</span><span>搜索需要绑定的项目，点击选择（单选）</span
                ><span class="text-yellow">（同一附件不支持挂载多个项目）</span>
              </div>
              <div>
                <div class="linkfile-search">
                  <el-select
                    v-model="keywords"
                    size="mini"
                    placeholder="输入项目名称或ID"
                    filterable
                    remote
                    :remote-method="searchProject"
                    :loading="loading"
                    style="width:100%"
                    @change="chooseProject"
                  >
                    <el-option v-for="item in projects" :key="item._id" :value="item._id" class="linkfile-search-item">
                      <el-button type="primary" size="mini">选择</el-button>
                      <span>{{ item.项目名称 }}</span> <span>（公司: {{ item.客户公司 }} 项目ID:{{ item.编号 }}）</span>
                    </el-option>
                  </el-select>
                </div>
                <div v-if="result._id">
                  <div>已选择:</div>
                  <div class="linkfile-result">
                    <span>{{ result.项目名称 }}</span>
                    <span>（公司: {{ result.客户公司 }} 项目ID:{{ result.编号 }}）</span>
                  </div>
                </div>
              </div>
              <div class="linkfile-type">
                <div class="linkfile-label">
                  <span class="text-red">*</span><span>请确认该附件具体类型（单选）</span
                  ><span class="text-yellow"> （附件类型如下，点击选择） </span>
                </div>
                <div class="linkfile-tags">
                  <el-radio
                    v-for="(type, k) in projectFileTypes"
                    :key="k"
                    v-model="formData.type"
                    size="small"
                    border
                    :label="type"
                    >{{ type }}
                  </el-radio>
                </div>
                <div class="linkfile-label">该附件是否需要特殊标签，请勾选</div>
                <div class="linkfile-tags">
                  <el-checkbox-group v-model="teshuTag">
                    <el-checkbox v-for="(type, k) in tagTypes" :key="k" :label="type">{{ type }} </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="linkfile-label">该附件是否同步到薪酬库，请勾选</div>
                <div class="linkfile-tags">
                  <el-radio v-model="isTongbu" size="small" :label="true">请同步 </el-radio>
                  <el-radio v-model="isTongbu" size="small" :label="false">暂不同步 </el-radio>
                </div>
                <div class="linkfile-text-center">
                  <el-button size="mini" type="primary" @click="bindProject">确认绑定</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="知识库附件" name="知识库附件">
            <div v-if="activeName == '知识库附件'">
              <div>
                <div class="linkfile-label"><span class="text-red">*</span><span>请选择这份附件的行业</span></div>
                <div class="linkfile-search">
                  <span>行业：</span>
                  <el-select v-model="formData.industryId" size="mini" placeholder="选择行业" filterable>
                    <el-option v-for="item in industries" :key="item.名称" :value="item._id" :label="item.名称">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <div class="linkfile-label">
                  <span class="text-red">*</span><span>请选择该附件类别</span
                  ><span class="text-yellow"> （知识库附件类别如下，点击选择） </span>
                </div>
                <div class="linkfile-tags">
                  <el-radio
                    v-for="(type, k) in knowledgeFileTypes"
                    :key="k"
                    v-model="formData.label"
                    size="small"
                    border
                    :label="type"
                    >{{ type }}
                  </el-radio>
                </div>
              </div>
              <div v-if="formData.label">
                <div class="linkfile-label"><span class="text-red">*</span><span>请确认该附件具体类型</span></div>
                <div class="linkfile-search">
                  <span>类型：</span>
                  <el-select v-model="formData.type" size="mini" placeholder="选择具体类型" filterable>
                    <el-option
                      v-for="item in knowledgeFileSubTypes[formData.label]"
                      :key="item"
                      :value="item"
                      :label="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="formData.label && formData.label != '行业知识'">
                <div class="linkfile-label">
                  <span v-if="formData.label == '职能模块'" class="text-red">*</span>请选择该附件对应的职能模块
                </div>
                <div class="linkfile-search">
                  <el-select v-model="formData.categoryId" size="mini" placeholder="选择职能模块" filterable>
                    <el-option v-for="item in categories" :key="item.名称" :value="item._id" :label="item.名称">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <div class="linkfile-label">请在下方本文框写上对于该附件的描述</div>
                <div><el-input v-model="formData.remark" type="textarea" placeholder="备注" /></div>
              </div>
              <div class="linkfile-label">该附件是否需要特殊标签，请勾选</div>
              <div class="linkfile-tags">
                <el-checkbox-group v-model="teshuTag">
                  <el-checkbox v-for="(type, k) in tagTypes" :key="k" :label="type">{{ type }} </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="linkfile-label">该附件是否同步到薪酬库，请勾选</div>
              <div class="linkfile-tags">
                <el-radio v-model="isTongbu" size="small" :label="true">请同步 </el-radio>
                <el-radio v-model="isTongbu" size="small" :label="false">暂不同步 </el-radio>
              </div>
              <div class="linkfile-text-center">
                <el-button size="mini" type="primary" @click="bindKnowledge">确认绑定</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog width="300px" title="新建人选" :visible.sync="addRadishVisiable" :close-on-click-modal="false" :modal="false" append-to-body>
      <div>
        <span>姓名：</span>
        <el-input v-model="radishForm.姓名" size="mini"></el-input>
      </div>
      <div>
        <span>公司：</span>
        <el-select
          v-model="radishForm.公司"
          size="mini"
          placeholder="输入公司的全称或简称"
          filterable
          remote
          :remote-method="searchCompany"
          :loading="loading"
          style="width:100%"
        >
          <el-option v-for="item in companies" :key="item._id" :value="item.简称" :label="item.简称"> </el-option>
        </el-select>
      </div>
      <div>
        <span>部门：</span>
        <el-input v-model="radishForm.部门" size="mini"></el-input>
      </div>
      <div>
        <span>职位：</span>
        <el-input v-model="radishForm.目前职位" size="mini"></el-input>
      </div>
      <div>
        <span>手机：</span>
        <el-input v-model="radishForm.手机" size="mini"></el-input>
      </div>
      <div>
        <span>座机：</span>
        <el-input v-model="radishForm.座机" size="mini"></el-input>
      </div>
      <div>
        <span>职能模块：</span>
        <el-select v-model="radishForm.职能模块" size="mini" multiple filterable>
          <el-option v-for="item in categories" :key="item.名称" :value="item.名称" :label="item.名称"> </el-option>
        </el-select>
      </div>
      <div v-if="dupData.id">
        <i class="el-icon-warning">候选人已存在:</i>&nbsp;
        <a :href="`#/radish-detail-blank/${dupData.id}`" target="_blank">{{ dupData.姓名 }}</a>
        <span> {{ dupData['公司'] }} {{ dupData['部门'] }}</span>
      </div>
      <div class="linkfile-text-center">
        <el-button size="mini" type="primary" @click="addRadish">确认新建</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  companyFileTypes,
  projectFileTypes,
  radishFileTypes,
  knowledgeFileTypes,
  knowledgeFileSubTypes,
} from '../constant/fileTypes'

export default {
  props: {
    visible: { type: Boolean, default: false },
    linkTarget: { type: Object, default: {} },
  },
  data() {
    return {
      companyFileTypes,
      projectFileTypes,
      radishFileTypes,
      knowledgeFileTypes,
      knowledgeFileSubTypes,
      radishes: [],
      companies: [],
      projects: [],
      industries: [],
      categories: [],
      formData: {},
      activeName: '人选附件',
      keywords: '',
      result: {},
      showTip: false,
      loading: false,
      radishForm: {},
      dupData: {},
      addRadishVisiable: false,
      tagTypes: ['薪酬数据', '组织架构', '市场情报', '项目报告'],
      teshuTag: [],
      isTongbu: false,
    }
  },
  async created() {
    const res = await app.service('company').getKnowledgeCategory()
    if (res.status !== 'success') return this.$message.error(`${res.msg}`)
    this.industries = res.data.industries
    this.categories = res.data.categories
  },
  methods: {
    async getCate() {
      const cats = await app.service('misc').simpleCategories()
      if (cats.status === 'success') {
        this.categories = cats.data
      }
    },
    async handleOpen() {
      this.handleTabClick()
      if (this.linkTarget) {
        console.log('linkTarget', this.linkTarget)
        // 打开预览
        const ref = window.app.root.$refs.cvPreview
        if (!ref) return
        await ref.getFile({ md5: this.linkTarget.md5 })
        ref.show()
        // 有姓名默认搜索
        if (this.linkTarget.data && this.linkTarget.data.姓名) {
          const { 姓名, 公司, 手机 } = this.linkTarget.data
          if (手机) this.keywords = 手机
          else if (公司) this.keywords = `${姓名} ${公司}`
          else this.keywords = 姓名
          await this.searchRadish()
        }
      }
      this.$emit('open')
    },
    handleTabClick() {
      this.formData = {}
      this.keywords = ''
      this.showTip = false
      this.result = {}
      this.teshuTag = []
      this.isTongbu = false
    },
    async searchRadish() {
      try {
        this.result = {}
        this.showTip = false
        if (this.loading) return false
        this.loading = true
        const { data } = await app.service('misc').searchEs({
          keywords: this.keywords,
          type: '人选',
          fields: ['姓名', '拼音', '公司', '部门', '职能模块', '手机'],
          and: true,
        })
        this.radishes = data || []
        if (this.radishes.length == 1) {
          this.chooseRadish(this.radishes[0]._id)
          this.showTip = true
        }
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },
    async searchCompany(keywords) {
      try {
        this.result = {}
        if (keywords !== '') {
          if (this.loading) return false
          this.loading = true
          const { data } = await app.service('company').serchCompany(keywords)
          this.companies = data || []
          this.loading = false
        }
      } catch (e) {
        console.error(e)
      }
    },
    async searchProject(keywords) {
      try {
        this.result = {}
        if (keywords !== '') {
          if (this.loading) return false
          this.loading = true
          const { data } = await app.service('project').search({
            keywords,
            type: '项目',
          })
          this.projects = data || []
          this.loading = false
        }
      } catch (e) {
        console.error(e)
      }
    },
    async chooseRadish(id) {
      this.result = this.radishes.find(item => item._id == id)
      this.keywords = ''
      this.radishes = []
    },
    async chooseCompany(id) {
      this.result = this.companies.find(item => item._id == id)
      this.keywords = ''
    },
    async chooseProject(id) {
      this.result = this.projects.find(item => item._id == id)
      this.keywords = ''
    },
    async updateDocument() {
      const params = {
        同步薪酬库: this.isTongbu,
        linkedBy: window.app.user.account || '未登录用户',
        linkedAt: Date.now(),
      }
      if (this.teshuTag && this.teshuTag.length > 0) {
        params.特殊标签 = this.teshuTag
      }
      if (this.formData && this.formData.type) {
        params.type = this.formData.type
      }
      await app.service('company').modifyDocument({ query: { _id: this.linkTarget._id }, data: params })
    },
    async bindRadish() {
      try {
        const { formData, linkTarget, result } = this
        if (!formData.type) return this.$message.error('请选择具体类型')
        if (!result._id) return this.$message.error('请选择人选')
        const extra = {
          id: result._id,
          idField: 'rid',
          fileType: formData.type,
          linkedAt: Date.now(),
          linkedBy: app.user.account,
        }
        if (formData.type === '推荐报告') {
          extra.isFinal = true
        }
        await app.service('project').upsertAttachmentFromOss(Object.assign(linkTarget, extra))
        await this.updateDocument()
        let linkVal = `${result['姓名']}${result['公司'] ? `-${result['公司']}` : ''}${
          result['部门'] ? `-${result['部门']}` : ''
        }`
        linkVal = `人选-${result['姓名']}`
        this.$emit('onLink', {
          id: result._id,
          fileType: formData.type,
          idField: 'rid',
          link: linkVal,
        })
        this.$emit('update:visible', false)
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async bindCompany() {
      try {
        const { formData, linkTarget, result } = this
        if (!formData.type) return this.$message.error('请选择具体类型')
        if (!result._id) return this.$message.error('请选择公司')
        await app.service('project').upsertAttachmentFromOss(
          Object.assign(linkTarget, {
            id: result._id,
            idField: 'companyId',
            fileType: formData.type,
            linkedAt: Date.now(),
            linkedBy: app.user.account,
          }),
        )
        await this.updateDocument()
        this.$emit('onLink', {
          id: result._id,
          fileType: formData.type,
          idField: 'companyId',
          link: `公司附件-${result['简称'] || result['公司名称']}`,
        })
        this.$emit('update:visible', false)
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async bindProject() {
      try {
        const { formData, linkTarget, result } = this
        if (!formData.type) return this.$message.error('请选择具体类型')
        if (!result._id) return this.$message.error('请选择项目')
        await app.service('project').upsertAttachmentFromOss(
          Object.assign(linkTarget, {
            id: result._id,
            idField: 'projectId',
            fileType: formData.type,
            linkedAt: Date.now(),
            linkedBy: app.user.account,
          }),
        )
        await this.updateDocument()
        let linkVal = `${result['客户公司']}${result['部门'] ? `-${result['部门']}` : ''}-${result['项目名称']}`
        linkVal = `项目-${result['客户公司']}-${result['项目名称']}`
        this.$emit('onLink', {
          id: result._id,
          fileType: formData.type,
          idField: 'projectId',
          link: linkVal,
        })
        this.$emit('update:visible', false)
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async bindKnowledge() {
      try {
        const { formData, linkTarget } = this
        if (!formData.industryId) return this.$message.error('请选择行业')
        if (!formData.label) return this.$message.error('请选择附件类别')
        if (!formData.type) return this.$message.error('请选择附件具体类型')
        if (!formData.categoryId && formData.label == '职能模块') return this.$message.error('请选择职能模块')
        const params = Object.assign(
          {
            createdAt: new Date().getTime(),
            fileId: linkTarget._id,
            uploader: linkTarget.uploader,
            originalname: linkTarget.originalname,
            src: linkTarget.src,
            linkedAt: Date.now(),
            linkedBy: app.user.account,
          },
          this.formData,
        )
        const result = await app.service('company').insertKnowledgeAtta(params)
        if (result.status == 'success') {
          await this.updateDocument()
          const zskResult = result.data
          const linkObj = {
            id: zskResult._id,
            fileType: formData.type,
            idField: '_id',
            link: `${formData.label}-${formData.type}`, // 行业知识-行业科普
            industryId: formData.industryId,
            categoryId: formData.categoryId || '',
            remark: formData.remark || '',
          }
          this.$emit('onLink', linkObj)
          this.$emit('update:visible', false)
        } else {
          throw new Error(`知识库添加失败:${result.msg}`)
        }
      } catch (e) {
        // console.error(e)
      }
    },
    showAddRadish() {
      if (this.linkTarget.data && this.linkTarget.data.姓名) {
        delete this.linkTarget.data.工作经历
        delete this.linkTarget.data.教育经历
        delete this.linkTarget.data.项目经历
        this.radishForm = this.linkTarget.data
      } else {
        this.radishForm = {}
      }
      this.addRadishVisiable = true
    },
    async addRadish() {
      this.dupData = {}
      if (this.radishForm.手机) {
        const dup = await app.service('radish').duplicate({ phone: this.radishForm.手机 })
        if (dup.msg == 'duplicate') {
          this.dupData = dup.data
          return false
        }
      }
      const result = await app.service('radish').insert(this.radishForm)
      if (result.status == 'success') {
        this.result = Object.assign({ _id: result.data.id }, this.radishForm)
        this.addRadishVisiable = false
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style>
.linkfile-dialog {
  left: 40%;
  right: 20%;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
}
.linkfile-dialog .el-dialog {
  margin: 0;
  min-height: 100vh;
}
.linkfile-dialog .el-dialog__body {
  padding: 10px;
  border-top: 1px solid #e6e6e6;
}
.linkfile-dialog .el-dialog__header {
  padding: 18px;
}
.linkfile-dialog .el-dialog__headerbtn {
  font-size: 24px;
  top: 16px;
}
.linkfile-tip-content {
  padding: 5px 40px;
  border-bottom: 1px solid #e6e6e6;
  color: #999;
}
.linkfile-label {
  color: #000;
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;
}
.linkfile-label .text-red {
  color: #f00;
  font-weight: bold;
}
.linkfile-label .text-yellow {
  color: #f63;
  font-size: 14px;
}
.linkfile-tags .el-radio,
.el-radio.is-bordered + .el-radio.is-bordered {
  margin: 5px;
}
.linkfile-search {
  padding: 5px;
}
.linkfile-search-item {
  border-bottom: 1px solid #eee;
}
.linkfile-search-item .el-button {
  margin-right: 10px;
}
.linkfile-text-center {
  text-align: center;
  padding-top: 5px;
}
.linkfile-result {
  padding: 10px;
  border: 1px solid #ddd;
  font-weight: bold;
  border-radius: 4px;
}
</style>
